export default {
  apiKey: "AIzaSyD0x6Az5Ya-XXQjIFYv_hurIbixe-f7Z1w",
  authDomain: "complysci-2278.firebaseapp.com",
  databaseURL: "https://complysci-2278.firebaseio.com",
  projectId: "complysci-2278",
  storageBucket: "complysci-2278.appspot.com",
  messagingSenderId: "314572706524",
  appId: "1:314572706524:web:577785af1d15066fda5a19",
};
